import React, { useEffect, useState } from "react";
import { Button, Modal, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { formatCents } from "../../../serviceProvider/components/accounting/shared/money";
import * as accounting from "../../../serviceProvider/components/accounting/receivables/api";
import { RefundModal } from "../../../serviceProvider/components/accounting/customers/CreditDialogs";
import "./InvoiceDialogs.css";

/**
 * GS-5: after a Rechnungskorrektur is sent, a customer credit may have come out of it (the
 * correction exceeded the open amount). Ask: refund now (SEPA transfer) or keep the credit
 * for the next invoice. Renders nothing when the correction left no open credit.
 */
const CreditPrompt = ({ correctionId, customerId, onClose, onDone }) => {
  const { t: ta } = useTranslation("accounting");
  const [credit, setCredit] = useState(null);
  const [refunding, setRefunding] = useState(false);

  useEffect(() => {
    setCredit(null);
    setRefunding(false);
    if (!correctionId || !customerId) return;
    let alive = true;
    accounting
      .listCredits({ customer: customerId, status: "open" })
      .then(res => {
        if (!alive) return;
        const found = (Array.isArray(res.data?.credits) ? res.data.credits : []).find(
          c => String(c.source?.ref) === String(correctionId) && Number(c.remaining) > 0
        );
        if (found) setCredit(found);
        else onClose?.();
      })
      .catch(() => alive && onClose?.());
    return () => {
      alive = false;
    };
  }, [correctionId, customerId]);

  if (!credit) return null;
  return (
    <>
      <Modal
        rootClassName="invoice-dialog"
        open={!refunding}
        title={ta("Customer credit of {{amount}}", { amount: formatCents(credit.remaining) })}
        width={520}
        onCancel={onClose}
        footer={[
          <Button key="keep" onClick={onClose}>
            {ta("Keep as credit for the next invoice")}
          </Button>,
          <Button key="refund" type="primary" onClick={() => setRefunding(true)}>
            {ta("Refund now (SEPA transfer)")}
          </Button>
        ]}
      >
        <Typography.Paragraph>
          {ta(
            "The invoice correction exceeds the open amount. The difference is money the customer already paid and is now a customer credit."
          )}
        </Typography.Paragraph>
      </Modal>
      <RefundModal
        open={refunding}
        credit={credit}
        customerId={customerId}
        onClose={() => {
          setRefunding(false);
          onClose?.();
        }}
        onDone={onDone}
      />
    </>
  );
};

export default CreditPrompt;
